<template>
  <div class="ResultsList">
    <ListItem v-for="(item, index) in resultsItems" :key="'listItem-' + index" :item="item"></ListItem>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ResultsList',
  props: ['resultsItems'],
  components: {
    ListItem
  },
  computed: {
    ...mapGetters({
      // searchTerm: 'getSearchTerm',
      resultsItems: 'getResultsItems',
      // resultsData: 'getResultsData',
      // fullResponse: 'getFullResponse',
      // activeFilters: 'getActiveFilters',
    })
  },
};
</script>

<style scoped lang="scss">
.ResultsList {
  padding: 30px 168px;
  @include smx { padding: 30px 15px; }
}
</style>
